// Third-party
import React from 'react';

// Components
import DatesDisclaimer from './DatesDisclaimer';

// Utils
import { getInvestmentInfoDates } from '../../../../utils/disclaimers/comparison';
import { formatMessageWithLocale } from '../../../../utils/i18n';
import { DISCLAIMER_KEYS } from '../../../../utils/disclaimers/constants';
import { COMPARISON_ITEM_TYPES } from '../../../../utils/constants';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  showItemNames?: boolean;
  locale?: Locale;
}

const FixedIncomeStyleDisclaimer = ({ items, locale, showItemNames }: Props) => {
  const fixedIncomeItems = items.filter(
    i =>
      i.type !== COMPARISON_ITEM_TYPES.STOCK &&
      !!i.disclaimers &&
      !i.disclaimers[DISCLAIMER_KEYS.FUND_FIXED_INCOME_STYLE_NOT_APPLICABLE] &&
      !i.disclaimers[DISCLAIMER_KEYS.PORTFOLIO_FIXED_INCOME_STYLE_NOT_APPLICABLE],
  );

  return (
    <DatesDisclaimer
      globalPrefix={formatMessageWithLocale('Disclaimers.FixedIncomeStyle', locale)}
      itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
      itemDates={getInvestmentInfoDates(fixedIncomeItems, locale)}
      showItemNames={showItemNames}
      locale={locale}
    />
  );
};

export default FixedIncomeStyleDisclaimer;
